import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["tab"];
  static classes = ["toggle", "add", "remove"];

  connect() {
    // toggle active tab if its id is part of the url #anchor
    const rawHash = window.location.hash || "";
    const id = rawHash.startsWith("#") ? rawHash.slice(1) : rawHash;
     if (id) {
      const tabs_container = this.context.valueObserver.stringMapObserver.element;
      try {
        const el = tabs_container?.querySelector("#" + id + "[data-action='tabs#toggle']");
        if (el) el.click();
      } catch {
        return;
      }
    }
  }

  toggle(event) {
    for (const tabTarget of this.tabTargets) {
      tabTarget.classList[
        tabTarget.getAttribute("for") === event.target.id ? "add" : "remove"
      ](...this.toggleClasses);

      tabTarget.classList[
        tabTarget.getAttribute("for") === event.target.id ? "add" : "remove"
      ](...this.addClasses);

      tabTarget.classList[
        tabTarget.getAttribute("for") === event.target.id ? "remove" : "add"
      ](...this.removeClasses);
    }

    // update anchor part in location bar
    // only if resulting from an actual user interaction
    if (document.readyState == "complete") {
      window.location.hash = event.target.id;
    }

    // update permalink url in footer
    const pl = document.getElementById("permalink");
    if (pl) {
      pl.href = "./#" + event.target.id;
    }
  }
}
